import { makeFgts } from 'src/main/factories/pages'

export default makeFgts
